import React from 'react'
import { ColourCode } from 'src/components/text/colour-code'
import { Strong } from 'src/components/text/strong'

interface Props {
  analystConsensusTargetPrice: string
  analystConsensusDiscount: string
  epsForecast: string
  tradingAt: string
  name: string
}

export const PriceForecast: React.FC<Props> = ({
  tradingAt,
  analystConsensusDiscount,
  epsForecast,
  name,
  analystConsensusTargetPrice,
}) => {
  const forecastPriceDifferencePercentNum = parseFloat(analystConsensusDiscount)

  if (
    !analystConsensusTargetPrice ||
    parseFloat(analystConsensusTargetPrice) < 0
  ) {
    return <p>We could not find analyst target price data for this security.</p>
  }

  return (
    <>
      <p>
        The analyst consensus target price for shares in {name} is{' '}
        <Strong>{analystConsensusTargetPrice}</Strong>.&nbsp; That is{' '}
        <ColourCode
          colour={
            forecastPriceDifferencePercentNum > 0
              ? 'green'
              : forecastPriceDifferencePercentNum < 0
              ? 'red'
              : 'default'
          }
        >
          {analystConsensusDiscount.replace('-', '').replace('+', '')}{' '}
          {forecastPriceDifferencePercentNum > 0
            ? 'above'
            : forecastPriceDifferencePercentNum < 0
            ? 'below'
            : 'equals'}{' '}
        </ColourCode>
        the last closing price of <Strong>{tradingAt}</Strong>.
      </p>
      <p>
        Analysts covering {name} currently have a consensus Earnings Per Share
        (EPS) forecast of <Strong>{epsForecast}</Strong> for the next financial
        year.
      </p>
    </>
  )
}
